<template>
  <div class="project-viewer-grid-container">
    <!-- here's the grid view -->
    <ProjectViewerGridItem
      v-for="(workData, i) in sortedData"
      :key="i"
      :workData="workData"
    />
  </div>
</template>

<script>
// vuex
import { mapGetters } from 'vuex'
// library
import Fuse from 'fuse.js'
import _ from 'lodash'
// internal
import { SORT_123, SORT_ABC } from '@/utils/constants'
// components
import ProjectViewerGridItem from './ProjectViewerGridItem'
export default {
  components: {
    ProjectViewerGridItem
  },
  data() {
    return {
      fuseObject: null,
      searchOptions: {
        includeScore: true,
        threshold: 0,
        ignoreLocation: true,
        keys: ['post_title', 'post_status', 'client']
      }
    }
  },
  computed: {
    ...mapGetters([
      'allProjectsData',
      'projectStatusFilters',
      'projectTextSearch',
      'projectTermFilters',
      'projectYearFilters',
      'projectSort'
    ]),
    yearFilteredData() {
      if (!this.allProjectsData) return []

      if (
        !this.projectYearFilters ||
        !this.projectYearFilters[0] ||
        !this.projectYearFilters[1]
      ) {
        return this.allProjectsData
      }

      return this.allProjectsData.filter(el => {
        let projYear

        if (el['go_live_date']) {
          projYear = new Date(el['go_live_date']).getFullYear()
        } else {
          // projYear = this.projectYearFilters[0]
          projYear = 2005
        }

        return (
          projYear >= this.projectYearFilters[0] &&
          projYear <= this.projectYearFilters[1]
        )
      })
    },
    statusFilteredData() {
      const activeStatus = Object.keys(this.projectStatusFilters).filter(
        key => {
          return this.projectStatusFilters[key].isSelected
        }
      )
      return this.yearFilteredData.filter(el => {
        return activeStatus.includes(el.post_status)
      })
    },
    termsFilteredData() {
      if (!this.allProjectsData) return []

      const activeTerms = _.keys(this.projectTermFilters).filter(term => {
        return this.projectTermFilters[term] !== false
      })

      if (_.isEmpty(activeTerms)) {
        return this.statusFilteredData
      }

      const overlap = (el, term) => {
        const termIDs = el[term].map(t => t.term_taxonomy_id)
        return !_.isEmpty(
          _.intersection(termIDs, this.projectTermFilters[term])
        )
      }

      const retVal = this.statusFilteredData.filter(el => {
        // start assuming it's true
        let innerReturn = true
        activeTerms.forEach(term => {
          // these two conditions will make it false
          if (el[term] === false || !overlap(el, term)) {
            innerReturn = false
          }
        })
        return innerReturn
      })

      return retVal
    },
    textFilteredData() {
      if (!this.termsFilteredData) return []
      //
      if (!this.projectTextSearch) return this.termsFilteredData

      const fuse = new Fuse(this.termsFilteredData, this.searchOptions)
      const results = fuse.search(this.projectTextSearch)
      return results.map(el => el.item)
    },
    sortedData() {
      if (!this.textFilteredData) return []

      let sortFunc, order
      if (this.projectSort === SORT_123) {
        sortFunc = d => {
          const now = new Date(Date.now())
          const date = new Date(d['go_live_date'])
          return now - date
        }
        order = 'asc'
      } else if (this.projectSort === SORT_ABC) {
        sortFunc = d => {
          return d['post_title']
        }
        order = 'asc'
      }

      return _.orderBy(this.textFilteredData, [sortFunc], [order])
    }
  },

  methods: {
    // ...mapActions([''])
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
.project-viewer-grid-container {
  margin-left: 350px;
  height: 100%;
  width: calc(100% - 350px);
  position: relative;
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
  justify-content: center;
  align-content: flex-start;
  overflow-y: scroll;
  padding-top: 25px;
}
</style>
